
@if (!isOfficer) {
  <h1>Notifier Contact Details</h1>
}
@if (isOfficer) {
  <h1>Department of Natural Resources and Mines, Manufacturing and Regional and Rural Development Officer Details</h1>
}
<form [formGroup]="form" class="form">
  <ol class="questions">
    @if (nextButtonClicked) {
      <app-global-validation-message [formInput]="form"> </app-global-validation-message>
    }
    <li class="group">
      <ol class="questions">
        @if (isOfficer) {
          <div>
            <li class="required">
              <fieldset>
                <legend> <span class="label">Do you have a scanned copy of the notification?</span> <abbr title="(required)"
              class="required">*</abbr>
            </legend>
            @if (nextButtonClicked && canAttachEvidenceOfConsentControl.errors != null) {
              <em class="red-alert">
                Please select an option
              </em>
            }
            <ul class="choices">
              <li>
                <input type="radio" formControlName="canAttachEvidenceOfConsent" [value]="true" required="required"
                  id="canAttachEvidenceOfConsent-yes" />
                  <label for="canAttachEvidenceOfConsent-yes">Yes</label>
                </li>
              </ul>
              @if (canAttachEvidenceOfConsentControl.value) {
                <fieldset>
                  <ol class="questions">
                    <li class="required" ng-class="{'invalid': !evidenceOfConsentValid}">
                      <label>
                        <span class="label" >Scanned copy of notification (up to 5 files)</span>
                        <small class="hint">
                          We accept: DOC, DOCX, PDF, ODF, JPG, BMP, TIFF, PNG, XLS or XLSX
                        </small>
                        <abbr title="(required)" class="required">*</abbr>
                        @if (!evidenceOfConsentValid) {
                          <em class="red-alert">Scanned copy of notification is required</em>
                        }
                      </label>
                      @if (!!evidenceOfConsentError) {
                        <div class="status warn">
                          <p>{{evidenceOfConsentError}}</p>
                        </div>
                      }
                      @if (evidenceOfConsentProvidedControl.value && evidenceOfConsentFileNames.length > 0) {
                        <div class="alert alert-success">
                          <h2><i class="fa fa-check-circle"></i> Scanned copy of notification Provided</h2>
                          <ul>
                            @for (evidenceOfConsent of evidenceOfConsentFileNames; track evidenceOfConsent) {
                              <li><strong>
                                {{evidenceOfConsent}}</strong> [<a (click)="removeConsent(evidenceOfConsent)">Remove</a>]
                              </li>
                            }
                          </ul>
                          <p>To replace the uploaded notification, drop or select a different file below.</p>
                          <button (click)="removeAllConsent()">Remove All</button>
                        </div>
                      }
                      <div class="center">
                        <ngx-file-drop dropZoneLabel="Drop files here" (onFileDrop)="uploadOrDroppedFiles($event)"
                          (onFileOver)="fileOver($event)" (onFileLeave)="fileLeave($event)"
                          accept={{validEvidenceOfConsentMimeType}} >
                          <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
                            Drag your files here, or &nbsp;&nbsp;&nbsp;
                            <button type="button" (click)="openFileSelector()">Browse Files</button>
                          </ng-template>
                        </ngx-file-drop>
                      </div>
                    </li>
                  </ol>
                </fieldset>
              }
              <ul class="choices">
                <li>
                  <input type="radio" formControlName="canAttachEvidenceOfConsent" [value]="false" required="required"
                    id="canAttachEvidenceOfConsent-no" />
                    <label for="canAttachEvidenceOfConsent-no">No</label>
                  </li>
                </ul>
                @if (canAttachEvidenceOfConsentControl.value === false) {
                  <fieldset>
                    <ol class="questions">
                      <li class="required" [ngClass]="{'invalid': !natureOfConsentPresentValid}">
                        <label for="natureOfConsent">
                          <span class="label">Describe nature of notification</span>
                          <abbr title="(required)" class="required">*</abbr>
                          @if (!natureOfConsentPresentValid) {
                            <em class="red-alert">
                              <span>Nature of notification is required</span>
                            </em>
                          }
                        </label>
                        <textarea rows="5" cols="40" formControlName="natureOfConsent" id="natureOfConsent" maxlength="1100"></textarea>
                        <!-- ng-change="validateNatureOfConsentPresent()" -->
                      </li>
                    </ol>
                  </fieldset>
                }
              </fieldset>
            </li>
            <li class="required">
              <label for="networkUserId">
                <span class="label">Network User ID</span>
                <abbr title="(required)" class="required">*</abbr>
              </label>
              @if ((nextButtonClicked || networkUserIdControl.dirty) && networkUserIdControl.errors != null) {
                <em class="red-alert">
                  Network User ID is required
                </em>
              }
              <input type="text" maxlength="255" formControlName="networkUserId" id="networkUserId"
                [ngClass]="{'error': (nextButtonClicked || networkUserIdControl.dirty) && networkUserIdControl.errors != null}" />
              </li>
            </div>
          }
          <li class="required">
            <label for="firstName">
              <span class="label">First name</span>
              <abbr title="(required)" class="required">*</abbr>
            </label>
            @if ((nextButtonClicked || firstNameControl.dirty) && firstNameControl.errors != null) {
              <em class="red-alert">
                First name is required
              </em>
            }
            <input type="text" maxlength="255" formControlName="firstName" id="firstName"
              [ngClass]="{'col-md-8': true, 'error': (nextButtonClicked || firstNameControl.dirty) && firstNameControl.errors != null}"/>
            </li>
            <li>
              <label for="middleName">
                <span class="label">Middle name</span>
              </label>
              <input type="text" class="col-md-8" formControlName="middleName" id="middleName"/>
            </li>
            <li class="required">
              <label for="lastName">
                <span class="label">Last name</span>
                <abbr title="(required)" class="required">*</abbr>
              </label>
              @if ((nextButtonClicked || lastNameControl.dirty) && lastNameControl.errors != null) {
                <em class="red-alert">
                  Last name is required
                </em>
              }
              <input type="text" formControlName="lastName" maxlength="255" id="lastName"
                [ngClass]="{'col-md-8': true, 'error': (nextButtonClicked || lastNameControl.dirty) && lastNameControl.errors != null}"/>
              </li>
              @if (!isOfficer) {
                <div>
                  <li>
                    <label for="companyName">
                      <span class="label">Company name</span>
                    </label>
                    <input type="text" formControlName="companyName" name="companyName" maxlength="255"
                      class="col-md-8" id="companyName"/>
                    </li>
                    <li class="group phoneGroup">
                      <label>
                        <span class="label">Phone or Mobile is required</span>
                        <abbr title="(required)" class="required">*</abbr>
                      </label>
                      @if (phoneControl.dirty && phoneControl.errors != null) {
                        <em class="red-alert" >
                          Phone is not valid
                        </em>
                      }
                      @if (mobileControl.dirty && mobileControl.errors != null) {
                        <em class="red-alert">
                          Mobile is not valid
                        </em>
                      }
                      @if ((nextButtonClicked || phoneControl.dirty || mobileControl.dirty) && !phoneControl.value && !mobileControl.value) {
                        <em class="red-alert">
                          Phone or Mobile is required
                        </em>
                      }
                      <ol class="questions compact">
                        <li>
                          <label for="phone">
                            <span class="label">Phone</span>
                          </label>
                          <input type="tel" formControlName="phone" maxlength="26" class="col-md-8" id="phone"/>
                        </li>
                        <li>
                          <label for="mobile">
                            <span class="label">Mobile</span>
                          </label>
                          <input type="tel" formControlName="mobile" maxlength="26" class="col-md-8" id="mobile"/>
                        </li>
                      </ol>
                    </li>
                  </div>
                }
                @if (isOfficer) {
                  <div>
                    <li class="required">
                      <label for="phoneOfficer">
                        <span class="label">Phone</span>
                        <abbr title="(required)" class="required">*</abbr>
                      </label>
                      @if ((nextButtonClicked || phoneOfficerControl.dirty) && phoneOfficerControl.errors != null) {
                        <em class="red-alert">
                          Phone is invalid
                        </em>
                      }
                      <input type="tel" formControlName="phoneOfficer" id="phoneOfficer"
                        [ngClass]="{'col-md-8': true, 'error': (nextButtonClicked || phoneOfficerControl.dirty) && phoneOfficerControl.errors != null}"/>
                      </li>
                    </div>
                  }
                  <li class="required">
                    <label for="email">
                      <span class="label">Email</span>
                      <abbr title="(required)" class="required">*</abbr>
                    </label>
                    @if ((nextButtonClicked || emailControl.dirty) && emailControl.errors != null) {
                      <em class="red-alert">
                        Email is invalid
                      </em>
                    }
                    <input type="text" formControlName="email" maxlength="200" id="email"
                      [ngClass]="{'col-md-8': true, 'error': (nextButtonClicked || emailControl.dirty) && emailControl.errors != null}"/>
                    </li>
                    @if (isOfficer) {
                      <div>
                        <li class="required">
                          <label for="location">
                            <span class="label">Location</span>
                            <abbr title="(required)" class="required">*</abbr>
                          </label>
                          @if ((nextButtonClicked || locationControl.dirty) && locationControl.errors != null) {
                            <em class="red-alert">
                              Location is invalid
                            </em>
                          }
                          <input type="text" formControlName="location" id="location"
                            [ngClass]="{'col-md-8': true, 'error': (nextButtonClicked || locationControl.dirty) && locationControl.errors != null}"/>
                          </li>
                        </div>
                      }
                    </ol>
                  </li>

                  @if (!isOfficer) {
                    <li class="group">
                      <fieldset>
                        <legend>
                          <h4>Home address</h4>
                        </legend>
                        <ol class="questions">
                          <li class="required">
                            <label for="homeAddressLine1">
                              <span class="label">Address line 1</span>
                              <abbr title="(required)" class="required">*</abbr>
                            </label>
                            @if ((nextButtonClicked || homeAddressLine1Control.dirty) && homeAddressLine1Control.errors != null) {
                              <em class="red-alert">
                                Address is required
                              </em>
                            }
                            <input type="text" formControlName="homeAddressLine1" maxlength="100" id="homeAddressLine1"
                              [ngClass]="{'col-md-8': true, 'error': (nextButtonClicked || homeAddressLine1Control.dirty) && homeAddressLine1Control.errors != null}"/>
                            </li>
                            <li>
                              <label for="homeAddressLine2">
                                <span class="label">Address line 2</span>
                              </label>
                              <input type="text" formControlName="homeAddressLine2" maxlength="100" class="col-md-8"
                                id="homeAddressLine2" />
                              </li>
                              <li class="group">
                                <ol class="questions compact">
                                  <li class="required">
                                    <label for="homeAddressSuburb">
                                      <span class="label">Town/Suburb</span>
                                      <abbr title="(required)" class="required">*</abbr>
                                    </label>
                                    @if ((nextButtonClicked || homeAddressSuburbControl.dirty)&& homeAddressSuburbControl.errors != null) {
                                      <em class="red-alert">
                                        Town/Suburb is required
                                      </em>
                                    }
                                    <input type="text" formControlName="homeAddressSuburb" maxlength="100" id="homeAddressSuburb"
                                      [ngClass]="{'col-md-8': true, 'error': (nextButtonClicked || homeAddressSuburbControl.dirty) && homeAddressSuburbControl.errors != null}"/>
                                    </li>
                                    <li class="required">
                                      <label for="homeAddressPostcode">
                                        <span class="label">Postcode</span>
                                        <abbr title="(required)" class="required">*</abbr>
                                      </label>
                                      @if ((nextButtonClicked || homeAddressPostcodeControl.dirty) && homeAddressPostcodeControl.errors != null) {
                                        <em class="red-alert">
                                          Postcode must be 4 numbers
                                        </em>
                                      }
                                      <input type="text" inputmode="numeric" formControlName="homeAddressPostcode" id="homeAddressPostcode" (keypress)="formatPostCode($event)"
                                        maxlength="4" [ngClass]="{'col-md-8': true, 'error': (nextButtonClicked || homeAddressPostcodeControl.dirty) && homeAddressPostcodeControl.errors != null}"/>
                                      </li>
                                    </ol>
                                  </li>
                                  <li>
                                    <label for="homeAddressStateId">
                                      <span class="label">State</span>
                                    </label>
                                    <select formControlName="homeAddressStateId" id="homeAddressStateId">
                                      @for (state of this.states; track state) {
                                        <option [value]="state.id">
                                          {{state.name}}
                                        </option>
                                      }
                                    </select>
                                    <br>
                                    </li>
                                    <li class="group">
                                      <fieldset>
                                        <legend>
                                          <h4>Mailing address</h4>
                                          <input type="checkbox" id="mailingAddressSameAsPhysicalAddress"
                                            formControlName="mailingAddressSameAsPhysicalAddress" />
                                            <label for="mailingAddressSameAsPhysicalAddress">Same as home address</label>
                                          </legend>
                                          @if (!mailingAddressSameAsPhysicalAddressControl.value) {
                                            <ol class="questions">
                                              <li class="required">
                                                <label for="mailingAddressLine1">
                                                  <span class="label">Address line 1</span>
                                                  <abbr title="(required)" class="required">*</abbr>
                                                </label>
                                                @if ((nextButtonClicked || mailingAddressLine1Control.dirty)  && mailingAddressLine1Control.errors != null) {
                                                  <em class="red-alert">
                                                    Address is required
                                                  </em>
                                                }
                                                <input type="text" formControlName="mailingAddressLine1" maxlength="100" id="mailingAddressLine1"
                                                  [ngClass]="{'col-md-8': true, 'error': (nextButtonClicked || mailingAddressLine1Control.dirty) && mailingAddressLine1Control.errors != null}"/>
                                                </li>
                                                <li>
                                                  <label for="mailingAddressLine2">
                                                    <span class="label">Address line 2</span>
                                                  </label>
                                                  <input type="text" maxlength="100" class="col-md-8" id="mailingAddressLine2" />
                                                </li>
                                                <li class="group">
                                                  <ol class="questions compact">
                                                    <li class="required">
                                                      <label for="mailingAddressSuburb">
                                                        <span class="label">Town/Suburb</span>
                                                        <abbr title="(required)" class="required">*</abbr>
                                                      </label>
                                                      @if ((nextButtonClicked || mailingAddressSuburbControl.dirty) && mailingAddressSuburbControl.errors != null) {
                                                        <em class="red-alert">
                                                          Town/Suburb is required
                                                        </em>
                                                      }
                                                      <input type="text" id="mailingAddressSuburb" maxlength="100" formControlName="mailingAddressSuburb"
                                                        [ngClass]="{'col-md-8': true, 'error': (nextButtonClicked || mailingAddressSuburbControl.dirty) && mailingAddressSuburbControl.errors != null}"/>
                                                      </li>
                                                      <li class="required">
                                                        <label for="mailingAddressPostcode">
                                                          <span class="label">Postcode</span>
                                                          <abbr title="(required)" class="required">*</abbr>
                                                        </label>
                                                        @if ((nextButtonClicked || mailingAddressPostcodeControl.dirty) && mailingAddressPostcodeControl.errors != null) {
                                                          <em class="red-alert">
                                                            Postcode must be 4 numbers
                                                          </em>
                                                        }
                                                        <input type="text" inputmode="numeric" formControlName="mailingAddressPostcode" id="mailingAddressPostcode" (keypress)="formatPostCode($event)"
                                                          maxlength="4" [ngClass]="{'col-md-8': true, 'error': (nextButtonClicked || mailingAddressPostcodeControl.dirty) && mailingAddressPostcodeControl.errors != null}"/>
                                                        </li>
                                                      </ol>
                                                    </li>
                                                    <li>
                                                      <label for="mailingAddressStateId">
                                                        <span class="label">State</span>
                                                      </label>
                                                      <select formControlName="mailingAddressStateId" id="mailingAddressStateId">
                                                        @for (state of this.states; track state) {
                                                          <option [value]="state.id">
                                                            {{state.name}}
                                                          </option>
                                                        }
                                                      </select>
                                                    </li>
                                                  </ol>
                                                }
                                              </fieldset>
                                            </li>
                                          </ol>
                                        </fieldset>
                                      </li>
                                    }
                                  </ol>
                                  <li class="footer">
                                    <ul class="actions">
                                      <li> <input class="qg-btn btn-global-secondary" type="submit" (click)="previous()" value="Previous" /> </li>
                                      <li> <em> <input class="qg-btn btn-primary" type="submit" (click)="next()" value="Next" /> </em> </li>
                                    </ul>
                                    <ul class="actions">
                                      <li>
                                        <a href (click)="cancel()">Cancel</a>
                                      </li>
                                    </ul>
                                  </li>
                                </form>
